<!-- <div class="container-fluid px-0">
    <form (ngSubmit)="onSubmit()" [formGroup]="form">
        <div *ngFor="let sp of searchParams" class="form-group">
            <symbiosis-search-form-item [searchParams]="sp" [form]="form" (categorySelected)="categorySelected($event)" (documentSelected)="documentSelected($event)" (taginputSeleted)="taginputSeleted($event)"></symbiosis-search-form-item>
        </div>
        <div class="form-group mb-2 d-flex justify-content-end">
            <span *ngIf="hasSavedDefault" class="saved-default-pill mr-2" [title]="savedDefaultValue">
                <span *ngIf="comp === 'statement'" class="pill-label">Default:</span>
                <span class="pill-value">{{ savedDefaultValue }}</span>
                <a class="clear-icon" title="Clear saved default" (click)="onClear()">&times;</a>
            </span>
            <button *ngIf="comp === 'statement' || comp === 'tag' || comp === 'document' || comp === 'system'"
                class="btn btn-secondary btn-sm mr-2" type="button" (click)="onSave()" [disabled]="!saveEnabled">Save</button>
            <button class="btn btn-primary btn-sm" type="submit">Search</button>
        </div> -->
        <!-- <div class="form-group mb-2" *ngIf="payLoad">
            <p>
                <strong>Search values</strong><br>{{payLoad}}
            </p>
        </div> -->
    <!-- </form>
</div> -->
<div class="container-fluid px-0">
    <form (ngSubmit)="onSubmit()" [formGroup]="form">
        <div *ngFor="let sp of searchParams" class="form-group">
            <symbiosis-search-form-item [searchParams]="sp" [form]="form" [externalCategoryItem]="selectedCategoryItem" (categorySelected)="categorySelected($event)" (documentSelected)="documentSelected($event)" (taginputSeleted)="taginputSeleted($event)"></symbiosis-search-form-item>
            <span *ngIf="hasSavedDefault && sp.key === getDefaultPillFieldKey()" class="saved-default-pill mt-1"
                [title]="'Click to reset to default: ' + savedDefaultValue" role="button" tabindex="0"
                (click)="onResetToDefault()" (keydown.enter)="onResetToDefault()" (keydown.space)="onResetToDefault()">
                <span class="pill-label">Default:</span>
                <span class="pill-value">{{ savedDefaultValue }}</span>
                <a class="clear-icon" title="Clear saved default" (click)="onClear(); $event.stopPropagation()">&times;</a>
            </span>
        </div>
        <div class="form-group mb-2 d-flex justify-content-end align-items-center">
            <button *ngIf="comp === 'statement' || comp === 'tag' || comp === 'document' || comp === 'system'"
                class="btn btn-secondary btn-sm mr-2" type="button" (click)="onSave()">
                Save
            </button>
            <button class="btn btn-primary btn-sm" type="submit">Search</button>
        </div>
    </form>
</div>